import { useQueryClient } from '@tanstack/vue-query'
import { getMyOrganizations } from '@/features/organizations/api/get-my-organizations'
import { MY_ORGANIZATIONS_QUERY_KEY } from '@/features/organizations/queries/useMyOrganizations'
import { useWorkspaceStore } from '@/stores/workspace'

/**
 * Refetches `GET /organizations/my` into the store after a workspace is created, renamed or
 * deleted, so the sidebar, switcher and permissions reflect it (and a stale selection is repaired).
 */
export function useReloadMyOrganizations() {
  const queryClient = useQueryClient()
  const workspaceStore = useWorkspaceStore()

  return async function reloadMyOrganizations(): Promise<void> {
    workspaceStore.setOrganizations(
      await queryClient.fetchQuery({
        queryKey: MY_ORGANIZATIONS_QUERY_KEY,
        queryFn: getMyOrganizations,
        staleTime: 0,
      }),
    )
  }
}
